<template>
	<div class="color-chooser">
		<div class="color-chooser__group" :class="{ 'color-chooser__group--simple': data.code.toLowerCase().includes('ary_color') }">
			<input type="text" class="form-control form-control-sm color-chooser__value" v-model="data.value" />
			<select
				v-if="!data.code.toLowerCase().includes('ary_color')"
				class="form-select form-select-sm color-chooser__preset"
				v-model="data.value"
			>
				<option value="">NONE</option>
				<option :key="i" v-for="(col, i) in colors" :value="col.value">{{ col.name }}</option>
			</select>
			<input type="color" v-model="data.value" class="color-chooser__picker" title="Choose your color" />
		</div>
	</div>
</template>

<script>
//import juniperAPI from '../../../../api/juniperApi'
export default {
	name: 'ColorChooser',
	props: ['data', 'themeOptions'],
	data() {
		return {
			colors: [],
		}
	},
	computed: {},
	watch: {
		'data.value': function() {
			this.$emit('change')
		},
	},
	created() {
		this.themeOptions.forEach(option => {
			if (option.code.includes('_COLOR')) {
				let obj = {
					name: option.code.replace('_', ' '),
					value: option.value,
				}
				this.colors.push(obj)
			}
		})
	},
	methods: {},
	emits: ['change'],
}
</script>
<style scoped>
.color-chooser {
	width: 100%;
}

.color-chooser__group {
	display: grid;
	grid-template-columns: minmax(0, 96px) minmax(0, 1fr) 10px;
	gap: 0;
	align-items: stretch;
	border: 1px solid #cbd5e1;
	border-radius: 10px;
	background: #ffffff;
	overflow: hidden;
}

.color-chooser__group--simple {
	grid-template-columns: minmax(0, 1fr) 10px;
}

.color-chooser__value,
.color-chooser__preset {
	height: 27px;
	border: 0 !important;
	border-radius: 0 !important;
	box-shadow: none !important;
}

.color-chooser__value {
	border-right: 1px solid #e2e8f0;
	background: #f2f5f8 !important;
}

.color-chooser__preset {
	border-right: 1px solid #e2e8f0;
	background: #e6ebf0 !important;
}

.color-chooser__preset,
.color-chooser__preset:focus,
.color-chooser__value,
.color-chooser__value:focus {
	border: 0 !important;
	border-radius: 0 !important;
	box-shadow: none !important;
}

.color-chooser__value:focus,
.color-chooser__preset:focus {
	background: inherit;
}

.color-chooser__picker {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	background-color: transparent;
	padding: 0;
	margin: 0;
	border: 0;
	cursor: pointer;
	width: 100%;
	height: 100%;
	overflow: hidden;
}
.color-chooser__picker::-webkit-color-swatch {
	border-radius: 0;
	border: 0;
}
.color-chooser__picker::-moz-color-swatch {
	border: 0;
	border-radius: 0;
}
</style>
